import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { isAuthenticated } from './utils/auth';
import LoginForm from './components/auth/LoginForm';
import Header from './components/common/Header';
import Sidebar from './components/common/Sidebar';
import Dashboard from './pages/Dashboard';
import DigitalCardManagement from './pages/DigitalCardManagement';
import UserManagement from './pages/UserManagement';
import Settings from './pages/Settings';
import DigitalIDShare from './components/digitalid/DigitalIDShare';
import './App.css';

function App() {
  const [authenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {


    setAuthenticated(isAuthenticated());
    setLoading(false);
  }, []);

  const handleLogin = (user) => {
    setAuthenticated(true);
    // Force reload to apply authentication state
    window.location.href = '/dashboard';
  };

  const handleLogout = () => {
    setAuthenticated(false);
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner"></div>
        <p>Loading Digital ID App...</p>
      </div>
    );
  }

  if (!authenticated) {
    return (
      <Router>
        <Routes>
          <Route path="/s/:shortcode" element={<DigitalIDShare />} />
          <Route path="/card/:name" element={<DigitalIDShare />} />
          <Route path="*" element={<LoginForm onLogin={handleLogin} />} />
        </Routes>
      </Router>
    );
  }

  return (
    <Router>
      <Routes>
        <Route path="/s/:shortcode" element={<DigitalIDShare />} />
        <Route path="/card/:name" element={<DigitalIDShare />} />
        <Route path="/*" element={
          <div className="app">
            <Header onLogout={handleLogout} onToggleSidebar={toggleSidebar} />
            <div className="app-layout">
              <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />
              {sidebarOpen && <div className="sidebar-overlay active" onClick={closeSidebar}></div>}
              <main className="main-content">
                <Routes>
                  <Route path="/" element={<Navigate to="/dashboard" />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/digital-cards/*" element={<DigitalCardManagement />} />
                  <Route path="/users" element={<UserManagement />} />
                  <Route path="/settings" element={<Settings />} />
                  <Route path="*" element={<Navigate to="/dashboard" />} />
                </Routes>
              </main>
            </div>
          </div>
        } />
      </Routes>
    </Router>
  );
}

export default App;
